import { render, staticRenderFns } from "./WidgetSettings.vue?vue&type=template&id=1497da8c&scoped=true"
import script from "./WidgetSettings.vue?vue&type=script&lang=ts"
export * from "./WidgetSettings.vue?vue&type=script&lang=ts"
import style0 from "./WidgetSettings.vue?vue&type=style&index=0&id=1497da8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1497da8c",
  null
  
)

export default component.exports